/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ImageOutlineIcon = function ImageOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11214_72210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20L11.3415 13.5762C11.7185 13.2463 12.2815 13.2463 12.6585 13.5762L20 20",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.1298 20.3755 20.1137 19.4529 20.6253L19.3415 20.7526L19.2913 20.7087C18.9002 20.8954 18.4623 21 18 21H6C5.53771 21 5.09985 20.8954 4.70876 20.7087L4.65852 20.7526L4.54716 20.6254C3.62451 20.1137 3 19.1298 3 18V6ZM6.66153 19H17.3385L12 14.3288L6.66153 19ZM19 17.7963L13.317 12.8237C12.563 12.1639 11.4371 12.1639 10.683 12.8237L5 17.7963V6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6V17.7963Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11214_72210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
export default ImageOutlineIcon;